import type { NavigationContainerRef } from '@react-navigation/native';

/**
 * No-op on web — Datadog's browser SDK tracks views from URL changes, so there
 * is no React Navigation registration to tear down.
 */
export function stopDatadogNavigationTracking(_container: NavigationContainerRef<any> | null) {}
